import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  loadingText: PropTypes.string.isRequired,
};

const defaultProps = {
  loadingText: "Loading...",
};

const LoadingDialog = ({ loadingText }) => (
  <div className="bg-white shadow flex justify-center items-center py-6 px-10">
    <div className="animate-pulse">{loadingText}</div>
  </div>
);

LoadingDialog.propTypes = propTypes;

LoadingDialog.defaultProps = defaultProps;

export default LoadingDialog;
